
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(3(149|435|883)|63(51|74)|2279|2695|5010|5817|9288|9693)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
